export default {"footer":"CemQu","plusFooter":"dnoKN","plusFooterWrapper":"MhBKK"};